import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../utils/axios";

const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchAmazonVendorTermSuggestionsData = createAsyncThunk(
  "amazonvendor/fetchAmazonVendorTermSuggestionsData",
  async ({ params }) => {
    const response = await axiosInstance.request({
      url: `/amazonvendor/suggest`,
      method: `GET`,
      params: params,
    });
    return response;
  }
);

const amazonVendorTermSuggestionsSlice = createSlice({
  name: "amazonvendor",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAmazonVendorTermSuggestionsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAmazonVendorTermSuggestionsData.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchAmazonVendorTermSuggestionsData.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const AmazonVendorTermSuggestionsReducer = amazonVendorTermSuggestionsSlice.reducer;

export default AmazonVendorTermSuggestionsReducer;

export const amazonVendorTermSuggestionsAction = amazonVendorTermSuggestionsSlice.actions;
